// @flow
import { createSelector } from 'reselect';
import { getCalendarLoading } from 'Store/calendar/calendar.selector';
import { priceRemoteSelector } from 'Store/price-remote/priceRemote.selector';

export const priceOfStaySelector = createSelector(
  priceRemoteSelector,
  ({ priceOfStay: { data } }) => data,
);
export const proposalsSelector = createSelector(
  priceOfStaySelector,
  ({ proposals }) => proposals || {},
);
export const priceOfStayIsLoadingSelector = createSelector(
  getCalendarLoading,
  priceRemoteSelector,
  (
    calendarIsLoading,
    { priceOfStay: { data: priceOfStay, isLoading: priceOfStayIsLoading, lastRequestId } },
  ) => {
    return (!priceOfStay && calendarIsLoading) || (lastRequestId !== -1 && priceOfStayIsLoading);
  },
);
